module.exports = __webpack_public_path__ + "img/logo_long.80a44f33.png";